import React from 'react';
import Avi from '../assets/profile.jpg';
import { Link, Redirect } from 'react-router-dom';
import {baseUrl} from './url';
import moment from 'moment';
import loader from '../assets/loader.svg';

class AdminProfile extends React.Component{
    constructor(){
        super()
        this.state={
            logout: false,
            profile: {},
            response: false
        }
        this.handleLogout = this.handleLogout.bind(this);
    }
    componentDidMount(){
        const token = localStorage.getItem('access_token');
        let retries = 0;
        fetch(`${baseUrl}/admin/profile`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            if(response.status === 403){
                localStorage.removeItem('access_token');
                return <Redirect to='/login' />
            }
            return response.json();
        })
        .then((responseJson) => {
            this.setState({
                profile: responseJson.data,
                response: true
            })
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
    }
    handleLogout(){
        localStorage.removeItem('access_token');
        this.setState({
            logout: true
        })
    }
    render(){
        const { logout, profile } = this.state;
        if (logout) {
            return <Redirect exact to='/dashboard'/>;
        } 
        let lastLogin = moment(profile.last_login).format('DD/MM/YYYY hh:mmA')
        return(
            <div className="admin-profile">
                <div className="container-fluid">
                    <div className="row">
                    {
                        !this.state.response &&
                        <div className="loader">
                            <img src={loader} alt=""/>
                        </div>
                    }
                    {
                        this.state.response &&
                        <div className="col-sm-4">
                            <div className="profile-details">
                                <Link to="/edit-admin"><button className="edit-btn">Edit</button></Link>
                                <div className="details">
                                    <img src={Avi} alt=""/>
                                    <h6>{profile.email}</h6>
                                    <p>Last login {lastLogin}</p>
                                </div>
                            </div>
                            <Link to="/change-password">
                                <div className="button-div">
                                    <h5>Change password</h5>
                                </div>
                            </Link>
                            <div className="button-div" onClick={this.handleLogout}>
                                <h6>Logout</h6>
                            </div>
                        </div>
                    }
                    </div>
                </div>
            </div>
        )
    }
}

export default AdminProfile;


// WEBPACK FOOTER //
// ./src/components/AdminProfile.js